import { useState, useEffect } from "react";
import { useAuth } from "../../../provider";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import axios from "axios";

import FormAlert from "../../../components/Alert/FormAlert";
import ButtonForm from "../../../components/Button/ButtonForm";
import DateInput from "../../../components/Forms/DateInput";
import SelectInputNew from "../../../components/Forms/SelectInputNew";
import { useNavigate, useLocation } from "react-router-dom";
import { API_URL } from "../../../constants";
import { CircularProgress, Stack, Box } from "@mui/material";
import { useTranslation } from "../../../language";

const getValidationSchema = (t) =>
  Yup.object({
    gender: Yup.string()
      .oneOf(["M", "F", "O"], t("val_gender_invalid"))
      .required(t("val_required")),
    birthdate: Yup.date()
      .max(new Date(), t("val_birthday_future"))
      .required(t("val_required")),
  });


const UserDataFormNew = () => {

  const { t, changeLanguage } = useTranslation();
  const { state, handleLogin } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/OnbQuest";
  const [errorMessage, setErrorMessage] = useState(null);

  const urlUpdateUser = `${API_URL}/api/auth/update_newprofile/${state.user.id}/`;

useEffect(() => {
  if (state.user?.language) {
    changeLanguage(state.user.language);
  }
}, [state.user?.language]);


  const handleSubmit = async (values, { setSubmitting, setFieldError }) => {
    setErrorMessage(null);

    try {
      
      const response = await axios.put(urlUpdateUser, values);

      if ([200, 201].includes(response.status)) {
        handleLogin({ user: { ...state.user, ...values }, token: state.token });

        await axios.patch(`${API_URL}/api/onboarding/status/`, {
          onboarding_status: 4,
        });
        setTimeout(() => {
          navigate(from, { replace: true });
        }, 2000);
      }

    } catch (error) {
      console.error("Form submit error:", error);

      const apiErrors = error.response?.data;

      if (apiErrors && typeof apiErrors === "object") {
        Object.entries(apiErrors).forEach(([field, messages]) => {
          setFieldError(
            field,
            Array.isArray(messages) ? messages.join(" ") : messages
          );
        });
        setErrorMessage(t("val_form_fix"));
      } else {
        setErrorMessage(t("val_server_error"));
      }
    } finally {
      setSubmitting(false);
    }
  };

  
  return (
    <>
      {errorMessage && (
        <FormAlert
          severity="error"
          title={t("val_form_error")}
          message={errorMessage}
          onClose={() => setErrorMessage(null)}
          sx={{ mb: 2 }}
        />
      )}

      <Formik
        initialValues={{
          gender: state.user.gender || "",
          birthdate: state.user.birthdate || "",
        }}
        validationSchema={getValidationSchema(t)}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <Stack spacing={2} alignItems="center">
              {isSubmitting && (
                <Box display="flex" justifyContent="center">
                  <CircularProgress size={24} />
                </Box>
              )}

              <SelectInputNew
                label= {t("onb_subscr24")}
                name="gender"
                options={[
                  { value: "", label: t("onb_subscr244") },
                  { value: "M", label: t("onb_subscr245") },
                  { value: "F", label: t("onb_subscr246") },
                  { value: "O", label: t("onb_subscr247") },
                ]}
              />

              <DateInput label= {t("onb_subscr25")} name="birthdate" />

              <ButtonForm
                name={t("onb_labb")}
                disabled={isSubmitting}
              />
            </Stack>
          </Form>
        )}
      </Formik>
    </>
  );
};

export default UserDataFormNew;



